module.exports = __webpack_public_path__ + "img/hill20.a6f9c391.jpg";